import React, { Suspense, lazy, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import * as settingsActions from "./modules/Estore/_redux/Estore/basicSettingsAction";
import { actions } from "./modules/Auth/_redux/authRedux";
import { setDefaultChannel } from "./modules/Inventory/_redux/sale-stock-channels/saleStockChannelsActions";

import { StagTest } from "./pages/StagTest";

import { Dashboard } from "./modules/Dashboard/pages/DashboardPage";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { NotificationPage } from "./modules/Dashboard/pages/DashboardPage/BasicStats/NotificationPage";
import { useLocation } from "react-router-dom";
import { clearAppStorageAndCacheDaily } from "../index";

import { notification } from "antd";
import { getUserByToken } from "./modules/Auth/_redux/authCrud";
import { getSettingKey, handleApiErrorResponse } from "./modules/Common/utils";
import { hasPermissions, Permission } from "./modules/Common/constants";
import AuthorizeContentRoute from "./modules/Common/partials/AuthorizeContentRoute";
import { getAllChannels } from "./modules/Inventory/_redux/sale-stock-channels/saleStockChannelsCrud";
import { getAccountingOnboardingStatus } from "./modules/Accounting/_redux/onboarding/AccountingOnboardingCrud";
import {
  accountingOnboardingStatuses,
  getAccountingOnboardingStatusEntity,
} from "./modules/Accounting/_redux/onboarding/accountingOnboardingUtils";
import * as sideBarActions from "../_metronic/layout/components/aside/navSlice";
// import SocketConfigurationButton from "./modules/Socket/SocketConfigurationButton";
import CometChatEmbed from "./cometchat/CometChatEmbed";
import KhubChatbotWidget from "./components/KhubChatbot/KhubChatbotWidget";
import KaiWidget, { KaiPage } from "./components/Kai/KaiWidget";
import KaiErrorBoundary from "./components/Kai/KaiErrorBoundary";
import AgentChatDock from "./modules/LiveVisitors/AgentChatDock";

const MessagingPage = lazy(() => import("./modules/Messaging/pages/MessagingPage"));
const QueriesPage = lazy(() => import("./modules/Queries/pages/QueriesPage"));
const SupportPage = lazy(() => import("./modules/Queries/pages/SupportPage"));
const EstoreThemePage = lazy(() => import("./modules/EstoreTheme/pages/ThemePage"));
const Estore = lazy(() => import("./modules/Estore/pages/EStorePage"));
const CatalogPage = lazy(() => import("./modules/Catalog/pages/CatalogPage"));
const SalePage = lazy(() => import("./modules/Sale/pages/SalePage"));
const DeliveryShippingPage = lazy(() => import("./modules/DeliveryShipping/pages/DeliveryShippingPage"));
const MarketingPage = lazy(() => import("./modules/Marketing/pages/MarketingPage"));
const ReportPage = lazy(() => import("./modules/Report/pages/ReportPage"));
const AccountingPage = lazy(() => import("./modules/Accounting/AccountingPage"));
const CustomPage = lazy(() => import("./modules/CustomPage"));
const PurchaseOrderOCR = lazy(() => import("./modules/PurchaseOrderOCR"));
const InventoryPage = lazy(() => import("./modules/Inventory/pages/InventoryPage"));
const UserPage = lazy(() => import("./modules/User/pages/UserPage"));
const ViewDetailModal = lazy(() => import("./modules/Catalog/pages/productss/product-detail"));
const AppsPage = lazy(() => import("./modules/App/pages/AppListing"));
const AppsInstallPage = lazy(() => import("./modules/App/pages/AppsInstallPage"));
const LiveVisitorsPage = lazy(() => import("./modules/LiveVisitors/pages/LiveVisitorsPage"));

export default function BasePage({ store }) {
  const dispatch = useDispatch();

  const location = useLocation();

  useEffect(() => {
    clearAppStorageAndCacheDaily();
  }, [location.pathname]);

  const { currentBasicState } = useSelector((state) => ({ currentBasicState: state.basicSettings }), shallowEqual);
  const { entity } = currentBasicState;
  const { user, authToken } = useSelector((state) => ({
    user: state.auth.user,
    authToken: state.auth.authToken,
  }));

  const setDefaultChannelInStore = async (params) => {
    try {
      const response = await getAllChannels(params);
      const { entities } = response.data;
      const defaultChannel = {
        id: entities[0].id,
        name: entities[0].name,
      };

      dispatch(setDefaultChannel(defaultChannel));
    } catch (err) {
      handleApiErrorResponse(err);
    }
  };

  // const currentOrigin = () => {
  //   const hostname = window.location.hostname;
  //   return hostname === "portal.localhost" ? hostname : `${hostname}/api`;
  // };

  useEffect(() => {
    // let reconnectAttempts = 0;
    // const socket = io(`ws://${currentOrigin()}`, {
    //   reconnection: true,
    //   reconnectionAttempts: 3, // Limit reconnection attempts to 3
    //   reconnectionDelay: 5000, // 2 seconds delay before the first reconnection attempt
    //   reconnectionDelayMax: 120000, // 2 minutes maximum delay between reconnection attempts
    //   query: {
    //     token: authToken,
    //   },
    //   pingTimeout: 30000, // 30 seconds until ping timeout
    //   pingInterval: 15000,
    // });

    // // socket.on("connect", () => {
    // //   console.log("Connected to the server");
    // // });
    // socket.on("notification", (data) => {
    //   // notification.open({message:data.message})
    //   dispatch(setNotification(data.message));
    //   console.log("Received message:", data);
    // });
    // socket.on("job_done", (data) => {
    //   if (!notification_block_list.includes(data.name)) {
    //     notification.open({
    //       message: `${BG_TASK_NAME_BG[data.name] || data.name} status ${CELERY_INTEGER_TASK_ID[data.status].name}`,
    //     });
    //     dispatch(setBackgorundJobs(data));
    //   }
    //   console.log("Received message:", data);
    // });

    // socket.on("unauthorized", (data) => {
    //   //  notification.open({message:data.message})
    //   console.log("Received message:", data);
    // });
    // socket.on("disconnect", (reason) => {
    //   console.log("Disconnected:", reason);
    // });
    // socket.io.on("reconnect_attempt", (attempt) => {
    //   reconnectAttempts++;
    //   console.log(`Reconnecting attempt: ${reconnectAttempts}`);
    // });

    getUserByToken()
      .then((res) => {
        dispatch(
          actions.requestUser({
            user: res.data,
          })
        );
      })
      .catch((err) => {
        err.response?.data?.errors?.map((error) => notification.error({ message: error }));
      });

    // Optimization: #1
    // Reducing no. of requests to server from 6 to 1

    dispatch(
      settingsActions.getSettings({
        types: ["admin-panel"],
        sub_types: ["basic", "msa", "email", "pos", "pos_invoice", "immutable_basic", "shipment_providers", "tax", "promotion_banner", "delivery_module", "shipping", "cometchat"],
      })
    );

    getAccountingOnboardingStatus()
      .then((response) => {
        dispatch(sideBarActions.setAccountingOnboardingStatus(getAccountingOnboardingStatusEntity(response)));
      })
      .catch(() => {
        dispatch(sideBarActions.setAccountingOnboardingStatus({ status: accountingOnboardingStatuses.INACTIVE }));
      });

    setDefaultChannelInStore({ is_primary: true })
    // dispatch(settingsActions.getProductListingColumnOrder({ type: "admin_panel", sub_type: "Catalog.Products.Listing.Column" }));
  }, []);

  const currentImmutableState = getSettingKey(currentBasicState?.entity, "IMMUTABLE_BASIC");
  const combinedUserId = `${currentImmutableState?.public_key}-${user?.entity?.id}`;
  const hasDashboardPermission = hasPermissions([Permission.DashboardView])[0];

  // Commenting for now
  // useEffect(() => {
  //   if (window.Intercom) {
  //     setTimeout(() => {
  //       window.Intercom("shutdown");
  //       window.Intercom("boot", {
  //         app_id: process.env.REACT_APP_INTERCOM_APP_ID,
  //         user_id: combinedUserId,
  //         name: `${user.entity?.first_name} (${currentBasicState.entity.Basic.account_title})`,
  //         email: user.entity?.email,
  //       });
  //     }, 500);
  //   }

  //   return () => {
  //     if (window.Intercom) {
  //       window.Intercom("shutdown");
  //     }
  //   };
  // }, [currentImmutableState?.public_key, currentBasicState?.entity.Basic.account_title, user?.entity?.first_name]);

  return (
    <>
      <CometChatEmbed user={user} />
      <KhubChatbotWidget user={user} authToken={authToken} />
      {location.pathname !== "/kai" && (
        <KaiErrorBoundary fallback={null}>
          <KaiWidget authToken={authToken} />
        </KaiErrorBoundary>
      )}
      {/* Ecom live shopping-assist agent dock — gated by the dedicated ecom_live_chat
          permission (master_admin always allowed). */}
      {authToken &&
        (user?.entity?.master_admin || hasPermissions([Permission.EcomLiveChat])[0]) && (
          <AgentChatDock />
        )}

      {/* <SocketConfigurationButton /> */}
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          {
            /* Redirect from root URL to the first permitted default page. */
            <Redirect exact from="/" to={hasDashboardPermission ? "/dashboard" : "/catalog"} />
          }
          {hasDashboardPermission && <ContentRoute path="/dashboard/notifications" component={NotificationPage} />}
          {hasDashboardPermission && <ContentRoute path="/dashboard" component={Dashboard} />}

          {/* <ContentRoute path="/dashboard-one" component={Demo1Dashboard} />
        <ContentRoute path="/dashboard-two" component={Demo2Dashboard} />
        <ContentRoute path="/dashboard-three" component={Demo3Dashboard} /> */}
          <Route path="/status" component={StagTest} />

          <Route path="/estore" component={Estore} />
          <Route path="/messaging" component={MessagingPage} />
          <Route path="/queries" component={QueriesPage} />
          <Route path="/kai" component={KaiPage} />
          <Route path="/support" component={SupportPage} />
          <Route path="/store" component={EstoreThemePage} />
          {/* <Route path="/appstore" component={AppThemePage} /> */}
          <Route path="/users" component={UserPage} />
          <Route path="/catalog" component={CatalogPage} />
          <Route path="/inventory" component={InventoryPage} />
          <Route path="/sale" component={SalePage} />
          <Route path="/delivery-shipping" component={DeliveryShippingPage} />
          <Route path="/marketing" component={MarketingPage} />
          <Route path="/abandon-carts" component={LiveVisitorsPage} />

          <AuthorizeContentRoute path="/reporting" component={ReportPage} permissions={[Permission.ReportingView]} />
          <Route path="/accounting" component={AccountingPage} />

          <Route path="/viewdetailmodal" component={ViewDetailModal} />

          <Route path="/apps/:name/install" component={AppsInstallPage} />
          <Route path="/apps" component={AppsPage} />

          <Route path="/custom-pages" component={CustomPage} />
          <Route path="/purchase-order-ocr" component={PurchaseOrderOCR} />
          <Redirect to="error/error-v1" />
        </Switch>
      </Suspense>
    </>
  );
}
